import t from 'tcomb';

const Anonymous = t.struct({
}, 'Anonymous');

module.exports = Anonymous;




/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/Anonymous.js
 **/